/// <amd-module name="Pipeline/Analytics/Common/Constants" />
export const percentile_value = "0.8";
export const percentile_text = "80";
export const maxItemsToShowInCharts = 10;
export const colors = ["#0078D4", "#550036", "#00A5B0", "#004378", "#E86E58", "#5C2E91", "#C19C00", "#603D30", "#E3008C", "#331950"];

export const enableSixMonthReportsFF = "WebAccess.Pipeline.Analytics.EnableSixMonthReports";
export const SuccessfulPipelines = "Succeeded runs duration";
